import { render, staticRenderFns } from "./NewCuentasbancarias.vue?vue&type=template&id=f5cc78bc&scoped=true&"
import script from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
export * from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
import style0 from "./NewCuentasbancarias.vue?vue&type=style&index=0&id=f5cc78bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cc78bc",
  null
  
)

export default component.exports